export default __webpack_public_path__ + "static/media/landingimage3.032ef6cc.png";